/* DalBam — Lunar Renewal · hızlı sepete ekleme + mobil satın alma çubuğu */
(function () {
  if (window.__lrQuickInit) return;
  window.__lrQuickInit = true;

  var COUNT_SELECTORS = [
    '.cart-count-bubble span:not(.visually-hidden)',
    '#cart-icon-bubble span:not(.visually-hidden)',
    '[data-cart-count]',
    '.cart-count',
    '.header__icons .cart-count-bubble span'
  ].join(',');

  function updateCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll(COUNT_SELECTORS).forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('lr:cart:updated', { detail: cart }));
        return cart;
      })
      .catch(function () { return null; });
  }

  /* --- sepete ekle --- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lr-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    var id = btn.getAttribute('data-lr-add');
    var original = btn.getAttribute('data-label') || btn.textContent.trim();
    btn.setAttribute('data-label', original);
    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-adding') || 'Ekleniyor…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (res) { if (!res.ok) throw new Error('add-failed'); return res.json(); })
      .then(function () {
        btn.textContent = btn.getAttribute('data-added') || 'Sepete eklendi';
        btn.classList.add('is-done');
        return updateCount();
      })
      .catch(function () {
        btn.textContent = btn.getAttribute('data-error') || 'Tekrar deneyin';
        btn.classList.add('is-error');
      })
      .then(function () {
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = original;
          btn.classList.remove('is-done');
          btn.classList.remove('is-error');
        }, 2200);
      });
  });

  /* --- mobil sabit satın alma çubuğu ---
     Yalnızca kullanıcı ana "Sepete Ekle" butonunu geçtikten sonra görünür;
     sayfanın başında görünmez. Kaydırmaya bağlıdır (IntersectionObserver'a gerek yok). */
  function initBuybar() {
    var bar = document.querySelector('.lr-buybar');
    var anchor = document.querySelector('.lr-atc__btn');
    if (!bar || !anchor) return;

    var ticking = false;
    function check() {
      ticking = false;
      var passed = anchor.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', passed);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuybar);
  } else {
    initBuybar();
  }
})();